// extracted by mini-css-extract-plugin
export default {"clt_82_0":"styles_clt_82_0__3YtW2","clt_82_2":"styles_clt_82_2__zvh76","clt_82_1":"styles_clt_82_1__4sErh"};